import React from "react";
import Footer from "../Footer/Footer";
import Testimonials from "./Testimonials";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "./../../css/Home.css";
import "./../../css/howitworks.css";
import "./../../css/icon_flat.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Header from "../Header";
import { Modal } from "react-bootstrap";

import {
  RegisterService,
  SplashState,
  userLoginDetails,
  Description,
  type_of_diet,
} from "./../../actions/index";
import Splash from "../Custom/Splash";
import Requestform from "./Requestform";
import HowitWorks from "./HowitWorks";
import HowitWorks_Onclick from "./HowitWorks_Onclick";
import CorporatePlan from "./CorporatePlan";
import { functions_for_users } from "../../function_constant";

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      timer: true,
      howitworks_onclick: false,
      showCorporate: false,
      isMobile: window.innerWidth <= 768,
    };

    this.fitnessSectionRef = React.createRef();
  }

  componentDidMount() {
    let self = this;
    // setTimeout fallback for splash screen
    setTimeout(() => {
      self.setState({ timer: false });
      self.props.splashState(self.state.timer);
    }, 3000);

    // Add resize listener to handle mobile detection
    this.handleResize = () => {
      this.setState({ isMobile: window.innerWidth <= 768 });
    };

    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    // Clean up the event listener
    window.removeEventListener("resize", this.handleResize);
  }

  fitnessService = () => {
    this.props.typeOfService("FITNESS");
    this.showhowitworks();
  };

  dietService = () => {
    this.props.typeOfService("DIET");
    if (localStorage.getItem("token")) {
      this.props.getdescription();
    } else {
      this.props.getdescription("some content");
    }

    this.props.history.push("/SelectService");
  };

  yogaService = () => {
    this.props.typeOfService("YOGA");
    this.showhowitworks();
  };

  showhowitworks() {
    this.setState({
      view: true,
    });
  }

  changeview() {
    this.setState({
      view: false,
    });
  }

  requestform() {
    this.setState({
      show: true,
    });
  }

  changeshow() {
    this.setState({
      show: false,
      showCorporate: false,
    });
  }

  callcorporate() {
    this.setState({
      showCorporate: true,
    });
  }

  showHowitWorks_OnclickModal() {
    this.setState({
      howitworks_onclick: true,
    });
  }

  hideHowitWorks_Onclick() {
    this.setState({
      howitworks_onclick: false,
    });
  }

  dietplantypes = (e) => {
    this.props.diet_plan(e.target.id);
    this.props.history.push("/diet");
  };

  postData(url = ``, data) {
    return new Promise(function (resolve, reject) {
      fetch(url, {
        method: "POST",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Content-Type": "text/plain; charset=utf-8",
          "Access-Control-Allow-Origin": "*",
          "Accept-Encoding": "gzip",
        },
        body: JSON.stringify(data),
      })
        .then((response) => resolve(response.json()))
        .catch((err) => reject(err));
    });
  }

  render() {
    const { isMobile } = this.state;

    return (
      <div>
        {this.state.timer === true && this.props.splashState === true ? (
          <Splash />
        ) : (
          <div className="gym-background background-watermark">
            <div id="landing">
              <div>
                <Header />
                <section className="container-fluidh">
                  <div className="row">
                    <div className="col-sm-3"></div>
                    <div className="banner-sec enroll_main  col-sm-6">
                      <h2 className="header-two">
                        Get fitter <br /> at home
                      </h2>
                      <p className="header-p">
                        Start your wellness journey with Fitfinity trainer We
                        offer personalized home training yoga sessions and
                        custom diet plans tailored just for you
                      </p>
                      <a
                        className="enroll_button"
                        onClick={() => {
                          if (this.fitnessSectionRef.current) {
                            this.fitnessSectionRef.current.scrollIntoView({
                              behavior: "smooth",
                            });
                          }
                        }}
                      >
                        <span className="enroll-content">Explore Now </span>
                      </a>
                    </div>
                    <div className="col-sm-3"></div>
                    {this.state.show ? null : (
                      <span className="requestformalignmentformobile">
                        <a
                          className="requestformalignment"
                          onClick={() => this.requestform()}
                        >
                          <img
                            src={require("./../../assests/conversation.png")}
                          />
                        </a>
                      </span>
                    )}
                  </div>
                </section>
              </div>
              <section className="container-fluid" ref={this.fitnessSectionRef}>
                <div className="row">
                  <div className="col-sm-6">
                    <img
                      src={
                        isMobile
                          ? require("./../../assests/step1mobile.png")
                          : require("./../../assests/step-1.png")
                      }
                      style={{ width: "100%" }}
                      alt="Personal Training"
                    />
                  </div>
                  <div className="enroll_main col-sm-6">
                    <h2 className="header-three">Personal Training at Home</h2>
                    <p className="header-p">
                      Transform your fitness with expert trainers at your
                      doorstep Build strength boost endurance and achieve
                      results—without leaving home
                    </p>
                    <a
                      className="service_button"
                      onClick={() => this.fitnessService()}
                    >
                      <span className="enroll-content">Enroll Now </span>
                    </a>
                  </div>
                </div>
              </section>

              <section className="container-fluid">
                <div className="row Curated-Diet-sec">
                  {/* Mobile-first: Image comes first */}
                  <div className="col-sm-6 order-sm-2 order-1">
                    <img
                      src={
                        isMobile
                          ? require("./../../assests/step2mobile.png")
                          : require("./../../assests/step-2.png")
                      }
                      style={{ width: "100%" }}
                      alt="Diet Plans & Nutrition"
                    />
                  </div>

                  {/* Mobile-first: Text comes after image */}
                  <div className="enroll_main col-sm-6 order-sm-1 order-2">
                    <h2 className="header-three">Diet Plans & Nutrition</h2>
                    <p className="header-p">
                      Stay energized and healthy with customized diet plans made
                      for your lifestyle Eat smart enjoy your meals and see real
                      fitness results
                    </p>
                    <a
                      className="service_button"
                      onClick={() => this.dietService()}
                    >
                      <span className="enroll-content">Enroll Now </span>
                    </a>
                  </div>
                </div>
              </section>

              <section className="container-fluid">
                <div className="row">
                  <div className="col-sm-6">
                    <img
                      src={
                        isMobile
                          ? require("./../../assests/step3mobile.png")
                          : require("./../../assests/step-3.png")
                      }
                      style={{ width: "100%" }}
                      alt="Personal Yoga at Home"
                    />
                  </div>
                  <div className="enroll_main col-sm-6">
                    <h2 className="header-three">Personal Yoga at Home</h2>
                    <p className="header-p">
                      Experience the power of yoga from the comfort of your home
                      Improve flexibility reduce stress and find balance with
                      guided personal sessions
                    </p>
                    <a
                      className="service_button"
                      onClick={() => this.yogaService()}
                    >
                      <span className="enroll-content">Enroll Now </span>
                    </a>
                  </div>
                </div>
              </section>
            </div>

            {this.state.show ? (
              <Requestform
                onHide={() => this.changeshow()}
                show={this.state.show}
              />
            ) : null}

            <Modal
              show={this.state.view}
              onHide={() => this.changeview()}
              backdrop={"static"}
              keyboard={false}
              size="sm"
              className="col-sm-12 col-md-6"
            >
              <Modal.Header closeButton className="Howitworks_Header">
                <h3>How it works</h3>
              </Modal.Header>
              <HowitWorks closehowitworks={() => this.changeview()} />
            </Modal>

            <Modal
              show={this.state.howitworks_onclick}
              onHide={() => this.hideHowitWorks_Onclick()}
              backdrop={"static"}
              keyboard={false}
            >
              <Modal.Header closeButton className="Howitworks_Header">
                <h3>How it works</h3>
              </Modal.Header>
              <HowitWorks_Onclick
                closehowitworks_Onclick={() => this.hideHowitWorks_Onclick()}
              />
            </Modal>

            <Modal
              show={this.state.showCorporate}
              onHide={() => this.changeshow()}
            >
              <Modal.Header closeButton></Modal.Header>
              <CorporatePlan onHide={() => this.changeshow()} />
            </Modal>

            <Footer />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentuser: state.sessionState.authUser,
    User: state.userDetail,
    splashState: state.splashState.splashState,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    typeOfService: (services) => {
      dispatch(RegisterService(services));
    },
    getdescription: (description) => {
      dispatch(Description(description));
    },
    splashState: (timer) => {
      dispatch(SplashState(timer));
    },
    storeProfile: (data) => {
      dispatch(userLoginDetails(data));
    },
    diet_plan: (typeofdiet) => {
      dispatch(type_of_diet(typeofdiet));
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));
